<template>
  <div>
    <b-modal id="photosMocal" ref="photosModal" size="lg" hide-footer v-on:shown="isShowing = true" v-on:hidden="isShowing = false">
    <div class="carousel-wrapper" v-if="isShowing">
      <carousel ref="houseCarousel"
                :paginationEnabled=false
                :navigationEnabled=true
                :navigationNextLabel='`<i class="fa fa-chevron-right fa-3x" aria-hidden="true"></i>`'
                :navigationPrevLabel='`<i class="fa fa-chevron-left fa-3x" aria-hidden="true"></i>`'
                :perPage="1"
                :navigateTo="[photo, false]">
        <slide v-for="(image, index) in photos" :key="index">
          <div class="row h-100">
            <div class="col my-auto">
              <img class="image" v-bind:src="image">
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    </b-modal>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  data () {
    return {
      isShowing: false
    }
  },
  props: {
    imageUrl: String,
    photos: Array,
    photo: Number
  },
  components: {
    Carousel,
    Slide
  },
  computed: {
    modifiedImageUrl () {
      if (this.imageUrl.includes('https://maps.googleapis.com')) return this.imageUrl
      else return this.imageUrl.replace('/xsmall/', '/xlarge/')
    }
  },
  methods: {
    hidePhotosModal () {
      this.$refs.photosModal.hide()
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  margin-right: 2rem;
  margin-left: 2rem;
  padding-right: 1rem;
  padding-left: 1rem;
}

.image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/PhotosModal.vue